
import React from 'react'

import activeImg from './images/tick_active.svg';
import inactiveImg from './images/tick_inactive.svg';


import  './styles/tick.scss'

const Tick = (props) => {
  ;
  return (
    <div className={"tick " + (!props.on && 'inactive')} onClick={props.onClick}>
      <img src={props.on? activeImg : inactiveImg} alt="Tick" />
      <div>{props.label}</div>
    </div>
  )
}

Tick.defaultProps = {

  label: '',
  light: false
}

export default Tick;



// WEBPACK FOOTER //
// ./src/components/ui/Tick.jsx